// src/router/routes.js
// This file contains just the routes configuration,
// separate from the router creation which requires browser APIs

export const routes = [
    // Generic Route
    {
      path: '/',
      name: 'GenericHomeView',
      component: () => import('../views/ParentViews/GenericHomeView.vue'),
      children: [
        {
          path: '/companies',
          name: 'CompaniesView',
          component: () => import('../views/CompaniesView/CompaniesView.vue'),
        },
      ]
    },
    {
      path: '/',
      name: 'ErrorView',
      component: () => import('../views/ParentViews/ErrorView.vue'),
      children: [
      {
        path: '/company-not-found',
        name: 'CompanyNotFoundError',
        component: () => import('../views/static/CompanyNotFoundView.vue'),
      },
      {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: () => import('../views/static/PrivacyPolicyView.vue'),
      },
      {
        path: '/:pathMatch(.*)*',
        name: '404View',
        component: () => import('../views/static/404View.vue'),
      },
      {
        path: '/500',
        name: '500View',
        component: () => import('../views/static/500View.vue'),
      },
    ]
    },
    // Company Route
    {
      path: '/:company',
      name: 'CompanyHome',
      component: () => import('../views/ParentViews/CompanySpecificHomeView.vue'),
      children: [{
        path: '/:company/accounts/',
        name: 'AccountsView',
        component: () => import('../views/AccountsViews/AccountsView.vue'),
      },
      {
        path: '/:company/MaintenanceContractor',
        name: 'contractorView',
        component: () => import('../views/ParentViews/ContractorMasterView.vue'),
        children:[{
          path: '/:company/MaintenanceContractor/:id',
          name: 'ContractorAccountView',
          component: () => import('../views/ContractorViews/ContractorView.vue'),
        }]
      },
      {
        path: '/:company/SalesVendor',
        name: 'vendorView',
        component: () => import('../views/ParentViews/VendorMasterView.vue'),
        children:[{
          path: '/:company/SalesVendor/:id',
          name: 'VendorAccountView',
          component: () => import('../views/VendorViews/VendorAccountView.vue'),
        }]
      },
      {
        path: '/:company/SalesApplicantBuyer',
        name: 'buyerView',
        component: () => import('../views/ParentViews/BuyerMasterView.vue'),
        children:[{
          path: '/:company/SalesApplicantBuyer/:id',
          name: 'BuyerAccountView',
          component: () => import('../views/BuyerViews/BuyerAccountView.vue'),
        }]
      },
      {
        path: '/:company/LettingsLandlord',
        name: 'landlordView',
        component: () => import('../views/ParentViews/LandlordMasterView.vue'),
        children:[{
          path: '/:company/LettingsLandlord/:id',
          name: 'LandlordAccountView',
          component: () => import('../views/LandlordViews/LandlordAccountView.vue'),
        }]
      },
      {
        path: '/:company/LettingsTenant',
        name: 'tenantView',
        component: () => import('../views/ParentViews/TenantMasterView.vue'),
        children:[{
          path: '/:company/LettingsTenant/:id',
          name: 'ActiveTenantView',
          component: () => import('../views/TenantViews/Active/ActiveTenantView.vue'),
        },
        {
          path: '/:company/LettingsProspect/:id',
          name: 'ProspectTenantView',
          component: () => import('../views/TenantViews/Prospect/ProspectTenantView.vue'),
      }]
      },
      {
        path: '/:company/:accountType/messaging-centre/:personOID',
        name: 'MessagingCentreView',
        component: () => import('../views/MessagingCentre/MessagingCentreView.vue')
      }
    ]
    }
  ];
  
  // Define scroll behavior separate from router creation
  export const scrollBehavior = () => {
    return { top: 0 };
  };